import React from 'react'
import { LinkAction } from '@leverege/molten/routes'
import { GlobalState } from '@leverege/ui-redux'
import { RelationshipBreadcrumbs } from '@leverege/molten/imagine'

import IntegrationsScreen from './IntegrationsScreen.jsx'
import IntegrationsErrorScreen from './IntegrationsErrorScreen.jsx'

const screenIcon = 'https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Nav%20Icons/nav-integrations-blue.svg'
const relationships = [ 'company' ]

export default function processRelationship( molten, relationship ) {
  if ( relationships.includes( relationship.options.path ) ) {
    const integrationsPath = `${relationship.urlPath}/:${relationship.blueprint.type}Id/integrations`
    const errorPath = `${relationship.urlPath}/:${relationship.blueprint.type}Id/integrationsError`

    molten.addPlugin( 'Action', LinkAction.create( {
      id : `actions.${relationship.path}.integrations`,
      icon : screenIcon,
      name : 'Integrations',
      path : integrationsPath,
      matches : { 
        use : 'navBar',
        client : 'ItemScreen',
        objectType : relationship.objectType,
        path : relationship.path
      },
      layout : { sort : 'd.4', sectionName : 'Company Management' },      
      handles : ( context ) => {
        const { clientProps } = context        
        const item = clientProps.item
        const companyId = item.id                
        const personas = GlobalState.get()?.ui?.personas
        const userId = GlobalState.get()?.auth?.profile?.id

        const integrationsAdmin = personas?.find( persona => persona?.name === 'integrationsAdmin' )
        if ( !integrationsAdmin ) {
          return false
        }

        const userRoles = integrationsAdmin?.userRoles
        const userRoleAtCompany = userRoles?.find( role => role.resourceId === companyId && role.userId === userId )
        
        return userRoleAtCompany
      }
    } ) )

    molten.addPlugin( 'Route', {
      id : `route.${relationship.path}.integrations`,
      matches : {
        client : 'ItemScreen',
        objectType : relationship.objectType,
        path : relationship.path
      },
      // default : true,
      path : integrationsPath,
      render : ( props ) => {
        return React.createElement( IntegrationsScreen, props )
      }
    } )

    molten.addPlugin( 'Route', {
      id : `route.${relationship.path}.integrations:breadcrumbs`,
      matches : { client : 'Breadcrumbs' },
      exact : true,
      path : integrationsPath,
      render : ( { match, ...rest } ) => {
        const rel = relationship.createItem( match )
        const name = 'Integrations'
        const extraCrumbs = [ { name, tooltip : name, url : integrationsPath } ]
        return React.createElement( RelationshipBreadcrumbs, { match, ...rest, extraCrumbs, relationship : rel } )
      }
    } )

    molten.addPlugin( 'Route', {
      id : `route.${relationship.path}.integrationsError`,
      matches : {
        client : 'ItemScreen',
        objectType : relationship.objectType,
        path : relationship.path
      },
      path : errorPath,
      render : ( props ) => {
        return React.createElement( IntegrationsErrorScreen, props )
      }
    } )

    molten.addPlugin( 'Route', {
      id : `route.${relationship.path}.integrationsError:breadcrumbs`,
      matches : { client : 'Breadcrumbs' },
      exact : true,
      path : errorPath,
      render : ( { match, ...rest } ) => {
        const rel = relationship.createItem( match )
        const name = 'Integrations'
        const extraCrumbs = [ { name, tooltip : name, url : errorPath } ]
        return React.createElement( RelationshipBreadcrumbs, { match, ...rest, extraCrumbs, relationship : rel } )
      }
    } )
  }
}
